import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config'; // Make sure this resolves correctly
import { useQuery,useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import ReactModal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';

function PrintTree() {

const navigate = useNavigate();

    const { menu, toggleMobileMenu } = useAppLayout();
    const chartContainerRef = useRef(null);
  const chartInstanceRef = useRef(null);

  const queryClient = useQueryClient();

  const getToken = () => localStorage.getItem('token');


 // Query to fetch family tree data
const { data: familyTreeData, isLoading: isLoadingFamilyTree, isError: isErrorFamilyTree } = useQuery({
    queryKey: ['familyTree'],
    queryFn: () =>
      axios
        .get(`${API_URL}/family-tree`, {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        })
        .then((res) => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });



   // Load OrgChart script when data is available
   useEffect(() => {
    if (!familyTreeData) return; // Wait for data to be available

    loadScript(`${process.env.PUBLIC_URL}/orgchart/orgchart.js`)
      .then(() => {
        initializeOrgChart(familyTreeData);
        //console.log("family TreeData:", familyTreeData);
      })
      .catch((error) => {
        console.error('Failed to load OrgChart script:', error);
      });

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [familyTreeData]); // Runs only when familyTreeData is updated


  const loadScript = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  const chartBgColor = "#EBF4ED";

 
  const initializeOrgChart = (data) => {
    if (!window.OrgChart) return;
    const isMobile = window.innerWidth <= 768;
    const OrgChart = window.OrgChart;

    OrgChart.templates.family_template = Object.assign({}, OrgChart.templates.ana);
    OrgChart.templates.family_template.size = [86, 86];
    OrgChart.templates.family_template.plus = '';
    OrgChart.templates.family_template.minus = '';
    OrgChart.templates.family_template.rippleRadius = 40;
    OrgChart.templates.family_template.name = '<text style="font-size: 12px;" fill="#000000" x="43" y="100" text-anchor="middle">{val}</text>';
    OrgChart.templates.family_template.title = '<text style="font-size: 12px;" fill="#aeaeae" x="43" y="115" text-anchor="middle">{val}</text>';
    OrgChart.templates.family_template.img = '<clipPath id="{randId}"><circle cx="43" cy="43" r="38.5"></circle></clipPath></circle><image preserveAspectRatio="xMidYMid slice" clip-path="url(#{randId})" xlink:href="{val}" x="3" y="3" width="80" height="78"></image>';
    OrgChart.templates.family_template.node = '<circle stroke-width="3" fill="none" stroke="#FF1493" cx="43" cy="43" r="41.5"></circle>';

   OrgChart.templates.family_template.svg = 
  `<svg xmlns="http://www.w3.org/2000/svg" 
       xmlns:xlink="http://www.w3.org/1999/xlink" 
       style="background-color:${chartBgColor};display:block;" 
       width="{w}" height="{h}" viewBox="{viewBox}">

        <defs>
         <pattern id="watermark" width="300" height="200" patternUnits="userSpaceOnUse">
           <text x="150" y="100" text-anchor="middle"
                 transform="rotate(-30 150 100)"
                 style="font-size:30px; font-weight:bold; fill:rgba(0,0,0,0.08);">
             ORET AFRICA
           </text>
         </pattern>
       </defs>

       <!-- Background with repeated watermark -->
       <rect width="100%" height="100%" fill="url(#watermark)" />


       {content}
   </svg>`;

    OrgChart.templates.family_template_blue = Object.assign({}, OrgChart.templates.family_template);
    OrgChart.templates.family_template_blue.node = '<circle stroke-width="3" fill="none" stroke="#039BE5" cx="43" cy="43" r="41.5"></circle>';

    const chart = new OrgChart(chartContainerRef.current, {
      template: 'family_template',
      
      enableSearch: false,
      levelSeparation: isMobile ? 60 : 100,
      siblingSeparation: isMobile ? 60 : 100,
      scaleInitial: isMobile ? OrgChart.match.boundary : 1,
      scaleMin: 0.5,
      scaleMax: 3,
     
      nodeBinding: {
        name: 'name',
        title: 'title',
        img: 'img',
      },
      tags: {
        blue: { template: 'family_template_blue' },
        partner: { template: 'family_template' },
      },

      nodeMouseClick: OrgChart.action.none, // override default popup

    });

  

    chart.on('render-link', (sender, args) => {
      if (args.cnode.ppid !== undefined) {
        args.html += '<use xlink:href="#baby" x="' + args.p.xa + '" y="' + args.p.ya + '"/>';
      }
    });

    chart.on('redraw', function () {
      const chartElement = document.querySelector('#tree svg');
      if (chartElement) {
        chartElement.style.touchAction = 'pan-x pan-y';
      }
    });


    chart.load(data);
    chartInstanceRef.current = chart;


  };


  const { data: familyNameData, isLoading, isError, refetch } = useQuery({
    queryKey: ['familyName'],
    queryFn: () =>
      axios.get(`${API_URL}/family-name-api`, { withCredentials: true })
        .then(res => res.data.family_name?.substring(0, 16) || ""),
    staleTime: 0,
    cacheTime: Infinity,
  });



  if (isLoadingFamilyTree) return( 
    <div className="loadingspinnerDiv">
  <div className="loadingspinner"></div>
</div>
     );
  
  if (isErrorFamilyTree) return <p>Error loading family tree data.</p>;



  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
    <Header onMenuClick={(value) => toggleMobileMenu()} />
    <Sidebar />
        <ToastContainer />

        <div className="page-wrapper">


<div className="content container-fluid">


<div className="d-flex justify-content-end mb-3 gap-2" style={{
        position: "absolute",
        zIndex: 100,
      }}>



        <Link  to='/family-tree' className='btn btn-default-primary'>
        <i className="fa fa-arrow-left" style={{ color: '#184A2C', fontSize: '30px',  }}></i>
        </Link>
    <button
      className="btn btn-outline-primary"
      onClick={() =>
        chartInstanceRef.current.exportPNG({
          
          padding: 30,
          useCORS: true,
          
      header: `
      <image href="https://oret.africa/tree/img/logo_1.png" x="20" y="10" height="40"/>
       <text x="50%" y="40" text-anchor="middle" 
         style="font-size:30px; font-weight:bold; fill:#ffffff; color:#184A2C; ">
         <center>${familyNameData}</center>
         
       </text>
     `,

     footer: `
       <text x="50%" y="20" text-anchor="middle" style="font-size:14px;">
         Generated by Oret Africa 
       </text>
       
     `,
     
          filename: "family_tree",
          openInNewTab: false
        })
      }
    >
      📷 Download PNG
    </button>


    <button
  className="btn btn-outline-success"
  onClick={() =>
    chartInstanceRef.current.exportPDF({
      background: "#184A2C",
      padding: 30,
      useCORS: true,
      
     
      header: `
       <text x="50%" y="40" text-anchor="middle" 
          style="font-size:40px; font-weight:bold; fill:#ffffff; color:#184A2C; ">
          <center>${familyNameData}</center>
        </text>
      `,

      footer: `
        <text x="50%" y="20" text-anchor="middle" style="font-size:14px;">
          Generated by Oret Africa 
        </text>
        
      `,

      filename: "family_tree",
      openInNewTab: false
    })
  }
>
  📄 Download PDF
</button>

   
  </div>

{/*background: "#ffff",
      padding: 30,
      useCORS: true,*/}


            
  <div id="tree" ref={chartContainerRef} style={{ width: '100%', height: '600px', }}></div>

       
          </div>
        </div>
      </div>
    
  );
}

export default PrintTree;